import { Chip, Tooltip } from '@mui/material';
import { CheckCircle, ErrorOutline, DescriptionOutlined } from '@mui/icons-material';

type Status = 'complete' | 'incomplete_details' | 'incomplete_documents' | undefined;

const MAP: Record<string, { label: string; color: 'success' | 'warning' | 'default'; icon: JSX.Element; tip: string }> = {
  complete: { label: 'Complete', color: 'success', icon: <CheckCircle fontSize="small" />, tip: 'All details & documents provided' },
  incomplete_details: { label: 'Incomplete details', color: 'warning', icon: <ErrorOutline fontSize="small" />, tip: 'Required detail fields are missing' },
  incomplete_documents: { label: 'Incomplete docs', color: 'default', icon: <DescriptionOutlined fontSize="small" />, tip: 'Required documents are not uploaded' },
};

/** Shows a dealer/client profile-completion status as a colored chip. */
export function ProfileStatusChip({ status }: { status: Status }) {
  if (!status) return null;
  const m = MAP[status];
  return (
    <Tooltip title={m.tip}>
      <Chip size="small" color={m.color} icon={m.icon} label={m.label} variant={m.color === 'default' ? 'outlined' : 'filled'} />
    </Tooltip>
  );
}
